import { create } from 'zustand'
import type { Notification } from '@/types'

interface NotificationStore {
  // State
  unreadCount: number
  notifications: Notification[]
  isOpen: boolean

  // Actions
  setUnreadCount: (count: number) => void
  incrementUnreadCount: () => void
  setNotifications: (notifications: Notification[]) => void
  addNotification: (notification: Notification) => void
  markRead: (ids: string[]) => void
  markAllRead: () => void
  togglePanel: () => void
  openPanel: () => void
  closePanel: () => void
}

export const useNotificationStore = create<NotificationStore>()((set) => ({
  unreadCount: 0,
  notifications: [],
  isOpen: false,

  setUnreadCount: (count) => set({ unreadCount: count }),

  incrementUnreadCount: () =>
    set((state) => ({ unreadCount: state.unreadCount + 1 })),

  setNotifications: (notifications) => set({ notifications }),

  addNotification: (notification) =>
    set((state) => ({
      notifications: [notification, ...state.notifications].slice(0, 50),
    })),

  markRead: (ids) =>
    set((state) => ({
      notifications: state.notifications.map((n) =>
        ids.includes(n.id) ? { ...n, is_read: true } : n,
      ),
      unreadCount: Math.max(
        0,
        state.unreadCount - ids.filter((id) =>
          state.notifications.find((n) => n.id === id && !n.is_read),
        ).length,
      ),
    })),

  markAllRead: () =>
    set((state) => ({
      notifications: state.notifications.map((n) => ({ ...n, is_read: true })),
      unreadCount: 0,
    })),

  togglePanel: () => set((state) => ({ isOpen: !state.isOpen })),
  openPanel: () => set({ isOpen: true }),

  closePanel: () => set({ isOpen: false }),
}))
